import { C } from "./Corporate/my-portfolio/constants";

export const CORE_API = process.env.REACT_APP_CORE_API;
export const REPORT = process.env.REACT_APP_REPORT;
export const SCORE_DEFINATION = process.env.REACT_APP_SCORE_DEFINATION;
export const AUTH_SERVER = process.env.REACT_APP_AUTH_SERVER;
export const REACT_APP_GOOGLE_ANALYST_CODE = process.env.REACT_APP_GOOGLE_ANALYST_CODE;
export const RATING_SEARCH = process.env.REACT_APP_RATING_SEARCH;
export const VIDEO_KYC_APP = process.env.REACT_APP_VIDEO_KYC_APP;
export const EWS_API = process.env.REACT_APP_EWS_API;
export const INTEGRATION_SERVICE = process.env.REACT_APP_INTEGRATION_SERVICE;
export const VENDOR_API = process.env.REACT_APP_VENDOR_API;
export const CUSTOMER_UI = process.env.REACT_APP_CUSTOMER_UI_URL;
export const SCORE_GEN = process.env.REACT_APP_SCORE_GEN;

